import type { FunctionComponent } from 'preact';

import { DialogButton } from 'Components';
import { SearchBoxDialogName } from 'Components/names';
import type { DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateFunctionInvoker, TemplateResult } from 'Components/types';
import { dialogOpened } from 'Core/actions/dialog';
import { usePopup } from 'Core/hooks/index';
import { useDispatch } from 'Core/store';
import { cloneSafe } from 'Utils/components';
import isMobile from 'Vendor/isMobile';

import SearchBox, { type Params as SearchBoxParams } from './searchBox';

export type Params = {
  searchBoxDialogButton: TemplateFunctionInvoker<DialogButtonTemplateParams>;
  searchBox: TemplateFunctionInvoker<SearchBoxParams>;
};

type Props = {
  template: TemplateFunction<Params>;
  name: string;
};

const SearchBoxDialogButton: FunctionComponent<Props> = ({ template, ...props }) => {
  const dispatch = useDispatch();
  const { opened } = usePopup(SearchBoxDialogName);

  const searchBoxDialogButton: TemplateFunctionInvoker<DialogButtonTemplateParams> = (templ) => {
    const dialogButtonProps = {
      template: templ,
      dialogName: SearchBoxDialogName,
    };
    return (<DialogButton {...dialogButtonProps} key="button" />) as TemplateResult;
  };

  const searchBox: TemplateFunctionInvoker<SearchBoxParams> = (templ) => {
    const searchBoxProps = {
      ...props,
      template: templ,
      disableAutoRequest: isMobile,
      onInputFocus: () => {
        if (isMobile && !opened) {
          dispatch(dialogOpened(SearchBoxDialogName));
        }
      },
    };
    return (<SearchBox {...searchBoxProps} key="search-box-dialog-button" />) as TemplateResult;
  };

  return cloneSafe(template.call({ searchBoxDialogButton, searchBox }), null);
};

export default SearchBoxDialogButton;
